import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ApiKeysComponent } from './api-keys.component';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';


@NgModule({
  declarations: [ApiKeysComponent],
  exports: [ApiKeysComponent],
  entryComponents: [ApiKeysComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatTableModule,
    MatToolbarModule,
    WsUiModule
  ]
})
export class ApiKeysModule { }
